// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

class Rules {
  static email (address) {
    var re = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{2,}$/
    if (re.test(address)) {
      return true
    } else {
      return 'Not a valid email address'
    }
  }

  static subdomain (value) {
    // Must be 3 characters long, may contain dashes in the middle
    var re = /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/
    if (re.test(value)) {
      return true
    } else {
      return 'Not a valid subdomain'
    }
  }

  static required (value) {
    if (value !== null && value !== '' && value !== [] && value !== undefined) {
      return true
    } else {
      return 'This field is required'
    }
  }

  // TODO: query from org, or pass as prop?
  static get PASSWORDLENGTH () {
    return 8
  }

  static get PASSWORDSTRENGTH () {
    return 2
  }

  static password (password, inputs = []) {
    var zxcvbn = require('zxcvbn')
    var strength = zxcvbn(password, ['phototag', 'tallyflow', ...inputs])
    if (password.length < this.PASSWORDLENGTH) {
      return 'Password must be at least ' + this.PASSWORDLENGTH + ' characters long.'
    } else if (strength.score < this.PASSWORDSTRENGTH) {
      return 'Password must be stronger.'
    } else {
      return true
    }
  }
}

export default Rules



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-common/components/rules.js
// module id = vGKo
// module chunks = 0